import { createFileRoute } from '@tanstack/react-router';
import { LegalPage } from '../components/legal-page';

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <LegalPage
      title="Privacy Policy"
      lead="Privacy Policy in preparation."
    >
      <p>
        Our Privacy Policy is being drafted with our healthcare counsel and will be posted here before
        first customer go-live.
      </p>
      <p>
        In the meantime, we're happy to share the working draft on request — email{' '}
        <a className="text-primary underline" href="mailto:hello@lynrx.co">
          hello@lynrx.co
        </a>{' '}
        and we'll send it.
      </p>
    </LegalPage>
  );
}
